import FileData from '@/model/General/FileData';

// --- helpers (arriba del componente) ---
function getSafeFilename(file: FileData): string {
  // prioriza name del File si existe; luego title; último, extensión por mime
  const fromBlob = file.blobFile instanceof File ? file.blobFile.name : undefined;

  if (fromBlob?.trim()) return fromBlob;
  if (file.title?.trim()) return file.title.trim();

  const mime = file.getFileMime();
  const ext = mime?.split('/')[1] || 'bin';

  return `archivo.${ext}`;
}

function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');

  a.href = url;
  a.download = filename;
  document.body.appendChild(a); // mejora compatibilidad (Safari/iOS)
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

async function downloadFromUrlPreferBlob(url: string, fallbackName: string) {
  // 1) Intento robusto: fetch + blob (requiere CORS habilitado en el CDN)
  try {
    const res = await fetch(url, { mode: 'cors' });

    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const cd = res.headers.get('content-disposition') || '';
    const m = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(cd);
    const serverName = decodeURIComponent(m?.[1] || m?.[2] || '');
    const blob = await res.blob();

    downloadBlob(blob, serverName || fallbackName);

    return;
  } catch {
    // 2) Fallback: <a download> (puede ser ignorado si es cross-origin)
    const a = document.createElement('a');

    a.href = url;
    a.download = fallbackName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // 3) Último recurso: abrir en nueva pestaña
    // window.open(url, '_blank', 'noopener,noreferrer');
  }
}

export async function downloadFile(file: FileData): Promise<void> {
  try {
    const filename = getSafeFilename(file);

    if (file.blobFile) {
      // ✅ Descarga directa sin ir a otra página
      downloadBlob(file.blobFile, filename);

      return;
    }

    if (file.fileUrl) {
      // 🔄 Intenta blob (CORS); si no, <a download>; último recurso: open
      await downloadFromUrlPreferBlob(file.fileUrl, filename);
    }
  } catch (error) {
    console.error('Error downloading file:', error);
  }
}
